import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultPUR2010_R01DetailDto, defaultPUR2010_R01HeaderDto, PUR2010_R01DetailDto, PUR2010_R01HeaderDto } from './Dto_PUR2010_R01';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface PUR2010_R01Filter {
	
	dateRange: DateRange | undefined	;
	customCd: string;
	customNm: string;
}
export interface Store_PUR2010_R01 {
	PUR2010_R01Filter: PUR2010_R01Filter;
	PUR2010_R01PastFilter: PUR2010_R01Filter;
	setPUR2010_R01Filter: (filter: Partial<Store_PUR2010_R01['PUR2010_R01Filter']>) => void;
	setPUR2010_R01PastFilter: (filter: Store_PUR2010_R01['PUR2010_R01PastFilter']) => void;
	
	// ====== 매출 리스트 및 선택/편집 ======
	PUR2010_R01List: PUR2010_R01HeaderDto[];
	setPUR2010_R01List: (dataList: PUR2010_R01HeaderDto[]) => void;

	editPUR2010_R01: PUR2010_R01HeaderDto | null;
	setEditPUR2010_R01: (editSale: PUR2010_R01HeaderDto | null) => void;

	selectedPUR2010_R01: PUR2010_R01HeaderDto | undefined;
	setSelectedPUR2010_R01: (data: PUR2010_R01HeaderDto | undefined) => void;
	initSelectedPUR2010_R01: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPUR2010_R01DetailList: string[];
	setDeletedPUR2010_R01DetailList: (idList: string[]) => void;
	addDeletedPUR2010_R01DetailList: (idList: string[]) => void;
	removeDeletedPUR2010_R01DetailList: (idList?: string[]) => void;

	// ====== 매출 상세(디테일) 데이터 ======
	PUR2010_R01DetailList: PUR2010_R01DetailDto[];
	setPUR2010_R01DetailList: (data: PUR2010_R01DetailDto[]) => void;
	insertPUR2010_R01DetailList: (data: PUR2010_R01DetailDto[], index?: number) => void;
	removePUR2010_R01DetailList: (index: number) => void;
	updatePUR2010_R01DetailList: (index: number, data: PUR2010_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedPUR2010_R01DetailList: string[];
	setSelectedPUR2010_R01DetailList: (idList: string[]) => void;
	addSelectedPUR2010_R01DetailList: (idList: string[]) => void;
	removeSelectedPUR2010_R01DetailList: (idList?: string[]) => void;
	initSelectedPUR2010_R01DetailList: () => void;

	originalPUR2010_R01DetailList: PUR2010_R01DetailDto[];
	setOriginalPUR2010_R01DetailList: (data: PUR2010_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;		setDetailFetchTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	// ====== 초기화 ======
	initData: () => void;

}

export const defaultPUR2010_R01Filter : PUR2010_R01Filter = {
	
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: ''
};

export const usePUR2010_R01Store = create<Store_PUR2010_R01>((set) => ({
	PUR2010_R01Filter: defaultPUR2010_R01Filter,
	PUR2010_R01PastFilter: defaultPUR2010_R01Filter,
	setPUR2010_R01Filter: (update) => set((state) => ({
		PUR2010_R01Filter: {
			...state.PUR2010_R01Filter,
			...update
		}
	})),
	setPUR2010_R01PastFilter: (filter: Store_PUR2010_R01['PUR2010_R01PastFilter']) => set((state) => {
		return {
			...state,
			PUR2010_R01PastFilter: filter
		}
	}),

	// ====== 매출 리스트 및 선택/편집 ======
	PUR2010_R01List: [],
	setPUR2010_R01List: (dataList: PUR2010_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PUR2010_R01List: dataList
		}
	}),

	editPUR2010_R01: defaultPUR2010_R01HeaderDto,
	setEditPUR2010_R01: (editSale: PUR2010_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editPUR2010_R01: editSale
		}
	}),

	selectedPUR2010_R01: undefined,
	
	setSelectedPUR2010_R01: (data: PUR2010_R01HeaderDto | undefined) => set((state) => {
		return { 
			selectedPUR2010_R01: data,
			selectedPUR2010_R01DetailList: [], deletedPUR2010_R01DetailList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
		};
	}),
	initSelectedPUR2010_R01: () => set({ selectedPUR2010_R01: undefined, editPUR2010_R01: defaultPUR2010_R01HeaderDto, PUR2010_R01DetailList: [], detailFetchTrigger: false	 }),

	// ====== 매출 상세(디테일) 데이터 ======
	PUR2010_R01DetailList: [],
	setPUR2010_R01DetailList: (data: PUR2010_R01DetailDto[]) => set((state) => {
		let newList: PUR2010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPUR2010_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PUR2010_R01DetailList: newList
		}
	}),
	insertPUR2010_R01DetailList: (data: PUR2010_R01DetailDto[], index?: number) => set((state) => {
		let newPUR2010_R01DetailList = [...state.PUR2010_R01DetailList];

		let targetRowData = newPUR2010_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newPUR2010_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newPUR2010_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newPUR2010_R01DetailList = newPUR2010_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newPUR2010_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultPUR2010_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newPUR2010_R01DetailList.splice(index, 0, ...newData);
		} else {
			newPUR2010_R01DetailList.push(...newData);
		}

		return {
			...state,
			PUR2010_R01DetailList: newPUR2010_R01DetailList
		}
	}),
	removePUR2010_R01DetailList: (index: number) => set((state) => {
		const newPUR2010_R01DetailList = [...state.PUR2010_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PUR2010_R01DetailList: newPUR2010_R01DetailList
		}
	}),
	updatePUR2010_R01DetailList: (valueIndex: number, data: PUR2010_R01DetailDto) => set((state) => {
		const _PUR2010_R01DetailList = state.PUR2010_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.billQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.billQty = 0;
		}
		return {
			...state,
			PUR2010_R01DetailList: _PUR2010_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPUR2010_R01DetailList: [],
	setDeletedPUR2010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPUR2010_R01DetailList: idList
		}
	}),
	addDeletedPUR2010_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedPUR2010_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.PUR2010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PUR2010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPUR2010_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedPUR2010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPUR2010_R01DetailList: [...state.deletedPUR2010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPUR2010_R01DetailList: [],
	setSelectedPUR2010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPUR2010_R01DetailList: idList
		}
	}),
	addSelectedPUR2010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedPUR2010_R01DetailList = [...state.selectedPUR2010_R01DetailList];
		if(idList.length > 0) {
			_selectedPUR2010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedPUR2010_R01DetailList: _selectedPUR2010_R01DetailList
		}
	}),
	removeSelectedPUR2010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPUR2010_R01DetailList: [...state.selectedPUR2010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPUR2010_R01DetailList: () => set({ selectedPUR2010_R01DetailList: [] }),

	originalPUR2010_R01DetailList: [],
	setOriginalPUR2010_R01DetailList: (data: PUR2010_R01DetailDto[]) => set((state) => {
		let newList: PUR2010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPUR2010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPUR2010_R01DetailList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		PUR2010_R01Filter: defaultPUR2010_R01Filter,
		PUR2010_R01PastFilter: defaultPUR2010_R01Filter,
		PUR2010_R01List: [],
		selectedPUR2010_R01: undefined,
		PUR2010_R01DetailList: [],
		deletedPUR2010_R01DetailList: [],
		selectedPUR2010_R01DetailList: [],
		editPUR2010_R01: defaultPUR2010_R01HeaderDto,
		allCount: 0,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
